import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Input, Modal, Select, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 }
}

interface Prop {
    clientData?: Client
    onChange?: () => void
}

interface Client {
    deal_id: string // 签单标识
    deal_item_name: string // 签单套餐
    nursing_care_type_desc: string // 护理模式
    hospital_escort_days: number // 医院陪护天数
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [employeeList, setEmployeeList] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    useEffect(() => {
        // 初始化产康师列表
        baseAxiosNoInfo('/global/employee_list_by_position', {
            params: {
                department_id: '',
                position_number: 21
            }

        }).then((res: any) => {
            if (res) {
                setEmployeeList(res)
            }
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/yuesao_center/customer/detail/distribute_hospital_escort', {
            deal_id: prop.clientData?.deal_id,
            belong_nursing_id: form.getFieldValue('belong_nursing_id'),
            service_start_date: form.getFieldValue('service_start_date') ? form.getFieldValue('service_start_date').format('YYYY-MM-DD') : '',
            service_days: form.getFieldValue('service_days')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 分配医院陪护 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>分配医院陪护</Button>

        <Modal title="分配医院陪护" width={450} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>签约套餐：{prop.clientData && prop.clientData?.deal_item_name}</p>
            <p>护理模式：{prop.clientData && prop.clientData?.nursing_care_type_desc}</p>
            <p>陪护天数：{prop.clientData && prop.clientData?.hospital_escort_days}</p>

            <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                <Form.Item required name="belong_nursing_id" label="护理师">
                    <Select >
                        {employeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))}
                    </Select>
                </Form.Item>

                <Form.Item required name="service_start_date" label="开始日期" >
                    <DatePicker />
                </Form.Item>

                <Form.Item required name="service_days" label="护理天数">
                    <Input placeholder="请输入天数" />
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>
}